import React from 'react';
import '../../../styles/style.css';

const LocationPoints = ({ points = [] }) => {
  if (points.length === 0) return null;

  return (
    <div className="routePointsWrapper flex-column">
      {points.map((point, index) => (
        <div key={point.id} className="routePointCard">

          {/* Заголовок + индекс (ОДИН КОНТЕЙНЕР) */}
          <div className="routePointHeader">
            <div className="routePointIndex">
              {index + 1}
            </div>

            <h3 className="routePointTitle">
              {point.name}
            </h3>
          </div>

          {/* Контент */}
          <div className="routePointContent">

  {point.photos && point.photos.length > 0 ? (
    <img
      src={point.photos[0].link}
      alt={point.name || "Фото точки"}
      className="routePointImage"
    />
  ) : (
    <div className="routePointImagePlaceholder">
      Нет фото
    </div>
  )}

  <div className="routePointDescription">
    {point.description && (
      <div>
        {point.description.split('\\n').map((line, index) => (
            <p key={index}>{line}</p>
          ))}
      </div>)}
  </div>
</div>
        </div>
      ))}
    </div>
  );
};

export default LocationPoints;